import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api/api.service';
import { IPagination } from '../../../shared/services/api/interface/pagination.interface';
import { Observable } from 'rxjs';

@Injectable({providedIn:'root'})
export class PriceInfoService {
  constructor(private readonly apiService: ApiService) {}

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`price-info/filter-list`, {event: event, filter: filter})
  }

  getById(id: number) {
    return this.apiService.get<any>(`price-info/${id}`);
  }

  create(data: any) {
    return this.apiService.post<any>('price-info/create', data);
  }

  update(data: any) {
    return this.apiService.patch<any>('price-info/update', data);
  }

  delete(id: number | string) {
    return this.apiService.delete(`price-info/delete/${id}`);
  }

  becomeCase(id:number){
        return this.apiService.post<{isSuccess:boolean,data:any,errorMessages:string[]}>('price-info/set-to-become-case', {id});
  }
}
